import React from 'react';
import { reportError } from './helpers/errorReporter';

class ErrorBoundary extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            hasError:false
        }
    }

    componentDidCatch(error){
        console.log('Unexpected fatal Error',error);
        reportError(error);
        this.setState({
            hasError:true
        });
    }

    render(){
        if(this.state.hasError){
            return (
                <h1>Something Unexpected happened!</h1>
            )
        }

        return this.props.children;
    }
}

export default ErrorBoundary;